import React from "react";
import EntityListPage, { StatusBadge } from "@/components/EntityListPage";
import { Badge } from "@/components/ui/badge";

const FIELDS = [
    { key: "name", label: "Customer name", required: true },
    { key: "code", label: "Customer code", placeholder: "Auto or manual" },
    {
        key: "type",
        label: "Type",
        type: "select",
        default: "retail",
        options: [
            { value: "retail", label: "Retail" },
            { value: "wholesale", label: "Wholesale" },
        ],
    },
    { key: "phone", label: "Phone" },
    { key: "email", label: "Email" },
    { key: "gst_number", label: "GSTIN" },
    { key: "address_line1", label: "Address" },
    { key: "city", label: "City" },
    { key: "state", label: "State" },
    { key: "pincode", label: "PIN code" },
    { key: "credit_limit", label: "Credit limit (₹)", type: "number", default: 0 },
    { key: "payment_terms_days", label: "Payment terms (days)", type: "number", default: 0 },
    { key: "tags", label: "Tags", type: "tags", full: true },
    { key: "notes", label: "Notes", type: "textarea", full: true },
    { key: "is_active", label: "Active", type: "boolean", default: true },
];

const COLUMNS = [
    {
        key: "name",
        label: "Customer",
        render: (r) => (
            <div>
                <div className="text-sm font-medium text-zinc-900">{r.name}</div>
                {r.code && <div className="text-xs text-zinc-500 font-mono">{r.code}</div>}
            </div>
        ),
    },
    {
        key: "type",
        label: "Type",
        render: (r) => (
            <Badge variant="secondary" className="text-[10px] uppercase tracking-widest">
                {r.type}
            </Badge>
        ),
    },
    { key: "phone", label: "Phone", render: (r) => <span className="text-xs text-zinc-700">{r.phone || "—"}</span> },
    { key: "city", label: "City", render: (r) => <span className="text-xs text-zinc-700">{r.city || "—"}</span> },
    {
        key: "credit_limit",
        label: "Credit",
        align: "right",
        render: (r) => (
            <span className="font-mono text-xs">₹{Number(r.credit_limit || 0).toLocaleString("en-IN")}</span>
        ),
    },
    { key: "is_active", label: "Status", render: (r) => <StatusBadge active={r.is_active} /> },
];

export default function CustomerBrain() {
    return (
        <EntityListPage
            testId="page-customer-brain"
            title="Customer Brain"
            description="Buying patterns, lifetime value, and relationship intelligence."
            resourcePath="/customers"
            fields={FIELDS}
            columns={COLUMNS}
            addLabel="Add customer"
            emptyLabel="No customers yet."
        />
    );
}
